// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-605f32e5] .centered-header .ag-header-group-cell-label{display:flex !important;justify-content:center !important;text-align:center !important;font-size:15px !important}", ""]);
// Exports
module.exports = exports;
